import { Component, OnInit, Input, Output, ViewChild, OnChanges, SimpleChanges, EventEmitter, Renderer2 } from '@angular/core';
import { UploadOptionType } from './upload-option-type';
import { DomSanitizer } from '@angular/platform-browser';
import { NzMessageService } from 'ng-zorro-antd';
import { UploadService } from './upload.service'
@Component({
  selector: 'ant-upload',
  template:`<div class="ant-upload ant-upload-select ant-upload-select-text" (click)="selectFile()">
  <span tabindex="0" class="ant-upload" role="button">
    <input #selectInput [accept]="options.accept" style="display: none;" type="file"
           [multiple]="options.multiple"
           (change)="onFileSelect($event)">
    <ng-content></ng-content>
  </span>
</div>
<div class="ant-upload-list"
     [ngClass]="{
       'ant-upload-list-text':this.options.listType=='text' || !this.options.listType,
       'ant-upload-list-picture':this.options.listType == 'picture'
      }">
  <div class="ant-upload-list-item "
       [ngClass]="{
         'ant-upload-list-item-uploading':file.status == 'uploading',
         'ant-upload-list-item-done':file.status == 'done',
         'ant-upload-list-item-error':file.status == 'error'
        }" 
       *ngFor="let file of fileList;let i = index;">
    <div class="ant-upload-list-item-info">
      <span>
        <i class="anticon anticon-paper-clip" 
           *ngIf="this.options.listType == 'text' || !this.options.listType"></i>
        <a class="ant-upload-list-item-thumbnail" 
           href="javascript:void(0);"
           *ngIf="this.options.listType == 'picture'"
           rel="noopener noreferrer" (click)="previewPicture(file)">
          <img [src]="file.objectURL?file.objectURL:(file.thumbUrl?file.thumbUrl:file.path)" [alt]="file.name" (error)="imageError($event,file.path)">
        </a>
        <a href="javascript:void(0);"
           rel="noopener noreferrer"
           class="ant-upload-list-item-name"
           [title]="file.name" (click)="previewPicture(file)">{{file.name}}</a>
      </span>
      <div class="ant-upload-list-item-progress" *ngIf="file.status == 'uploading'" >
        <nz-progress [ngModel]="file.progress || 0" [nzShowInfo]="false" [nzStrokeWidth]="2"></nz-progress>
      </div>
    </div>
    <i title="删除文件" class="anticon anticon-cross" (click)="remove(i,file)"></i></div>
</div>




`,
  styles: [`.ant-upload {
  font-size: 12px;
  outline: 0;
}
.ant-upload-btn {
  display: block;
  width: 100%;
  outline: none;
}
.ant-upload input[type="file"] {
  cursor: pointer;
}
.ant-upload.ant-upload-select {
  display: inline-block;
}
.ant-upload.ant-upload-select-picture-card {
  border: 1px dashed #d9d9d9;
  width: 96px;
  height: 96px;
  border-radius: 4px;
  background-color: #fbfbfb;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.3s ease;
  display: inline-block;
  vertical-align: top;
  margin-right: 8px;
  margin-bottom: 8px;
}
.ant-upload.ant-upload-select-picture-card > .ant-upload {
  display: block;
  width: 100%;
  height: 100%;
  padding: 20px 0;
}
.ant-upload.ant-upload-select-picture-card:hover {
  border-color: #108ee9;
}
.ant-upload.ant-upload-drag {
  border: 1px dashed #d9d9d9;
  transition: border-color 0.3s ease;
  cursor: pointer;
  border-radius: 4px;
  text-align: center;
  width: 100%;
  height: 100%;
  position: relative;
}
.ant-upload.ant-upload-drag.ant-upload-drag-hover:not(.ant-upload-disabled) {
  border: 2px dashed #49a9ee;
}
.ant-upload.ant-upload-drag.ant-upload-disabled {
  cursor: not-allowed;
}
.ant-upload.ant-upload-drag .ant-upload-btn {
  display: table;
  height: 100%;
}
.ant-upload.ant-upload-drag .ant-upload-drag-container {
  display: table-cell;
  vertical-align: middle;
}
.ant-upload.ant-upload-drag:not(.ant-upload-disabled):hover {
  border-color: #49a9ee;
}
.ant-upload.ant-upload-drag p.ant-upload-drag-icon {
  height: 60px;
  margin-bottom: 24px;
}
.ant-upload.ant-upload-drag p.ant-upload-drag-icon .anticon {
  font-size: 80px;
  margin-top: -5px;
  color: #49a9ee;
}
.ant-upload.ant-upload-drag p.ant-upload-text {
  font-size: 14px;
}
.ant-upload.ant-upload-drag p.ant-upload-hint {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.43);
}
.ant-upload.ant-upload-drag .anticon-plus {
  font-size: 30px;
  transition: all 0.3s ease;
  color: rgba(0, 0, 0, 0.25);
}
.ant-upload.ant-upload-drag .anticon-plus:hover {
  color: rgba(0, 0, 0, 0.43);
}
.ant-upload.ant-upload-drag:hover .anticon-plus {
  color: rgba(0, 0, 0, 0.43);
}
.ant-upload-list {
  overflow: hidden;
}
.ant-upload-list-item {
  overflow: hidden;
  margin-top: 8px;
  font-size: 12px;
  position: relative;
  height: 24px;
}
.ant-upload-list-item-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-left: 16px;
  width: 100%;
  display: inline-block;
}
.ant-upload-list-item-info {
  line-height: 24px;
  padding: 0 12px 0 4px;
  transition: background-color 0.3s;
}
.ant-upload-list-item-info .anticon-loading,
.ant-upload-list-item-info .anticon-paper-clip {
  margin-right: 4px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.43);
  position: absolute;
  top: 5.5px;
}
.ant-upload-list-item .anticon-cross {
  display: inline-block;
  font-size: 12px;
  font-size: 10px \9;
  transform: scale(0.83333333) rotate(0deg);
  /* IE6-IE8 */
  -ms-filter: "progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)";
  zoom: 1;
  transition: all .3s;
  opacity: 0;
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 4px;
  color: rgba(0, 0, 0, 0.43);
  line-height: 24px;
}
:root .ant-upload-list-item .anticon-cross {
  filter: none;
}
:root .ant-upload-list-item .anticon-cross {
  font-size: 12px;
}
.ant-upload-list-item .anticon-cross:hover {
  color: rgba(0, 0, 0, 0.65);
}
.ant-upload-list-item:hover .ant-upload-list-item-info {
  background-color: #ecf6fd;
}
.ant-upload-list-item:hover .anticon-cross {
  opacity: 1;
}
.ant-upload-list-item-error,
.ant-upload-list-item-error .anticon-paper-clip,
.ant-upload-list-item-error .ant-upload-list-item-name {
  color: #f04134;
}
.ant-upload-list-item-error .anticon-cross {
  opacity: 1;
  color: #f04134 !important;
}
.ant-upload-list-item-progress {
  line-height: 0;
  font-size: 12px;
  position: absolute;
  width: 100%;
  bottom: 0;
}
.ant-upload-list-picture .ant-upload-list-item,
.ant-upload-list-picture-card .ant-upload-list-item {
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  height: 66px;
  position: relative;
}
.ant-upload-list-picture .ant-upload-list-item:hover,
.ant-upload-list-picture-card .ant-upload-list-item:hover {
  background: transparent;
}
.ant-upload-list-picture .ant-upload-list-item-error,
.ant-upload-list-picture-card .ant-upload-list-item-error {
  border-color: #f04134;
}
.ant-upload-list-picture .ant-upload-list-item-info,
.ant-upload-list-picture-card .ant-upload-list-item-info {
  padding: 0;
}
.ant-upload-list-picture .ant-upload-list-item:hover .ant-upload-list-item-info,
.ant-upload-list-picture-card .ant-upload-list-item:hover .ant-upload-list-item-info {
  background: transparent;
}
.ant-upload-list-picture .ant-upload-list-item-uploading,
.ant-upload-list-picture-card .ant-upload-list-item-uploading {
  border-style: dashed;
}
.ant-upload-list-picture .ant-upload-list-item-thumbnail,
.ant-upload-list-picture-card .ant-upload-list-item-thumbnail {
  width: 48px;
  height: 48px;
  position: absolute;
  top: 8px;
  left: 8px;
}
.ant-upload-list-picture .ant-upload-list-item-thumbnail img,
.ant-upload-list-picture-card .ant-upload-list-item-thumbnail img {
  width: 48px;
  height: 48px;
  display: block;
  overflow: hidden;
  border-radius: 4px;
}
.ant-upload-list-picture .ant-upload-list-item-thumbnail.anticon:before,
.ant-upload-list-picture-card .ant-upload-list-item-thumbnail.anticon:before {
  line-height: 48px;
  font-size: 24px;
  color: rgba(0, 0, 0, 0.43);
}
.ant-upload-list-picture .ant-upload-list-item-name,
.ant-upload-list-picture-card .ant-upload-list-item-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0 0 0 8px;
  line-height: 44px;
  transition: all .3s;
  padding-left: 48px;
  padding-right: 8px;
  max-width: 100%;
  display: inline-block;
  box-sizing: border-box;
}
.ant-upload-list-picture .ant-upload-list-item-uploading .ant-upload-list-item-name,
.ant-upload-list-picture-card .ant-upload-list-item-uploading .ant-upload-list-item-name {
  line-height: 28px;
}
.ant-upload-list-picture .ant-upload-list-item-progress,
.ant-upload-list-picture-card .ant-upload-list-item-progress {
  padding-left: 56px;
  margin-top: 0;
}
.ant-upload-list-picture .anticon-cross,
.ant-upload-list-picture-card .anticon-cross {
  position: absolute;
  right: 8px;
  top: 8px;
  line-height: 1;
}
.ant-upload-list-picture-card {
  display: inline;
}
.ant-upload-list-picture-card .ant-upload-list-item {
  float: left;
  width: 96px;
  height: 96px;
  margin: 0 8px 8px 0;
}
.ant-upload-list-picture-card .ant-upload-list-item-info {
  height: 100%;
  position: relative;
}
.ant-upload-list-picture-card .ant-upload-list-item-info:before {
  content: ' ';
  position: absolute;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.5);
  transition: all .3s;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.ant-upload-list-picture-card .ant-upload-list-item:hover .ant-upload-list-item-info:before {
  opacity: 1;
}
.ant-upload-list-picture-card .ant-upload-list-item-actions {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  white-space: nowrap;
  opacity: 0;
  transition: all .3s;
}
.ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-eye-o,
.ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-delete {
  z-index: 10;
  transition: all .3s;
  cursor: pointer;
  font-size: 16px;
  width: 16px;
  color: rgba(255, 255, 255, 0.91);
  margin: 0 4px;
}
.ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-eye-o:hover,
.ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-delete:hover {
  color: #fff;
}
.ant-upload-list-picture-card .ant-upload-list-item-info:hover + .ant-upload-list-item-actions,
.ant-upload-list-picture-card .ant-upload-list-item-actions:hover {
  opacity: 1;
}
.ant-upload-list-picture-card .ant-upload-list-item-thumbnail,
.ant-upload-list-picture-card .ant-upload-list-item-thumbnail img {
  display: block;
  width: 100%;
  height: 100%;
  position: static;
}
.ant-upload-list-picture-card .ant-upload-list-item-name {
  display: none;
}
.ant-upload-list-picture-card .ant-upload-list-item-uploading.ant-upload-list-item {
  background-color: #fbfbfb;
}
.ant-upload-list-picture-card .ant-upload-list-item-uploading .ant-upload-list-item-info {
  height: auto;
}
.ant-upload-list-picture-card .ant-upload-list-item-uploading .ant-upload-list-item-info:before,
.ant-upload-list-picture-card .ant-upload-list-item-uploading .ant-upload-list-item-info .anticon-eye-o,
.ant-upload-list-picture-card .ant-upload-list-item-uploading .ant-upload-list-item-info .anticon-delete {
  display: none;
}
.ant-upload-list-picture-card .ant-upload-list-item-uploading-text {
  margin-top: 18px;
  color: rgba(0, 0, 0, 0.43);
}
.ant-upload-list-picture-card .ant-upload-list-item-progress {
  padding-left: 0;
}
.ant-upload-list .ant-upload-success-icon {
  color: #00a854;
  font-weight: bold;
}
.ant-upload-list .ant-upload-animate-enter,
.ant-upload-list .ant-upload-animate-leave,
.ant-upload-list .ant-upload-animate-inline-enter,
.ant-upload-list .ant-upload-animate-inline-leave {
  animation-duration: .3s;
  animation-fill-mode: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}
.ant-upload-list .ant-upload-animate-enter {
  animation-name: uploadAnimateIn;
}
.ant-upload-list .ant-upload-animate-leave {
  animation-name: uploadAnimateOut;
}
.ant-upload-list .ant-upload-animate-inline-enter {
  animation-name: uploadAnimateInlineIn;
}
.ant-upload-list .ant-upload-animate-inline-leave {
  animation-name: uploadAnimateInlineOut;
}
@keyframes uploadAnimateIn {
  from {
    height: 0;
    margin: 0;
    opacity: 0;
    padding: 0;
  }
}
@keyframes uploadAnimateOut {
  to {
    height: 0;
    margin: 0;
    padding: 0;
    opacity: 0;
  }
}
@keyframes uploadAnimateInlineIn {
  from {
    width: 0;
    height: 0;
    margin: 0;
    opacity: 0;
    padding: 0;
  }
}
@keyframes uploadAnimateInlineOut {
  to {
    width: 0;
    height: 0;
    margin: 0;
    padding: 0;
    opacity: 0;
  }
}
`],
  providers: []
})

export class UploadComponent implements OnInit, OnChanges {
  public files = [];
  public messages = [];
  /**
   * 默认上传的最大尺寸
   */
  protected maxFileSize: number;
  @Input() options: UploadOptionType;
  @Input() fileList: Object[];
  @Output() onSelect = new EventEmitter();
  @Output() onError = new EventEmitter();
  @Output() onSuccess = new EventEmitter();
  @Output() removeFile = new EventEmitter();
  @Output() onPreviewPicture = new EventEmitter();
  @ViewChild('selectInput') selectInput: any;
  constructor(
    public sanitizer: DomSanitizer,
    private _message: NzMessageService,
    public _us: UploadService,
    public renderer: Renderer2
  ) { }
  ngOnInit() {
    this.maxFileSize = this.options.maxFileSize || 2000000;
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['fileList']) {
      this.fileList = changes['fileList'].currentValue;
    }else {
      // this.fileList = [];
    }
  }
  selectFile() {
    this.selectInput.nativeElement.click();
  }

  /**
   * 选择文件
   * @param event
   */
  onFileSelect(event) {
    this.files = [];
    let files = event.dataTransfer ? event.dataTransfer.files : event.target.files;
    for (let i = 0; i < files.length; i++) {
      this.messages = [];
      let file = files[i];
      this.onSelect.emit({ file, files });
      if (this.validate(file)) {
        /**
         * 过滤上传的文件格式等
         */
        if (this.messages[0].type === 'genre') {
          this._message.error('您这个' + file.name + '上传类型不符合', { nzDuration: 2000 });
        }
        if (this.messages[0].type === 'size') {
          this._message.error('您这个' + this.messages[0].name + '文件大小过大', { nzDuration: 2000 });
        }
      } else {
        if (this.isImage(file)) {
          file.objectURL = this.sanitizer.bypassSecurityTrustUrl((window.URL.createObjectURL(files[i])));
        }else {
          let fileExt = file.name.substring(file.name.lastIndexOf('.') + 1);
          file.objectURL = this.matchPicture(fileExt);
        }
        file.status = 'uploading';
        this.files.push(files[i]);
        this.fileList.push(files[i]);
        event.target.value = '';
      }
    }
    if (this.hasFiles()) {
      for (let i = 0; i < this.files.length; i++) {
        this.upload(this.files[i].name, this.files[i]);
      }
    }
    // group1/M00/17/7F/rB9kmlmNfZCAIL0oAAzodQCbVVc825.jpg
  }
  /**
   * 上传文件
   */
  upload(name: string, file: any) {
    let xhr = new XMLHttpRequest(),
      formData = new FormData();
      if (this.options.setParameter) {
        for (let key in this.options.setParameter) {
          if (this.options.setParameter.hasOwnProperty(key)) {
            if (key === 'savepath') {
              this.options.setParameter[key] = this.options.setParameter[key] + name;
            }
            formData.append(key, this.options.setParameter[key]);
          }
        }
      }
    formData.append('file', file);
    xhr.upload.addEventListener('progress', (e: ProgressEvent) => {
      if (e.lengthComputable) {
        file.progress = Math.round((e.loaded * 100) / e.total);
      }
    }, false);
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        file.progress = 0;
        if (xhr.status >= 200 && xhr.status < 300) {
          let data = JSON.parse(xhr.response);
          if (data.Success || data.result === 0) {
            this.onSuccess.emit({ data: data, files: this.files });
            file.path = this.options.previewUrlPrex + (data.Data ? data.Data[0] : data.data[0].Url);
            file.status = 'done';
            return;
          }
          this.onError.emit({ data: JSON.parse(xhr.response), files: this.files });
          // this._message.error(data.Message?data.Message:data.message);
          file.status = 'error';
        } else {
          file.status = 'error';
        }
      }
    };
    let method = this.options.method || 'post';
    xhr.open(method, this.options.url, true);
    if (this.options.headerOptions) {
      for (let key in this.options.headerOptions) {
        if (this.options.headerOptions.hasOwnProperty(key)) {
          xhr.setRequestHeader(key, this.options.headerOptions[key]);
        }
      }
    }
    xhr.send(formData);
  }

  /**
   * 验证传入的文件，是否符合
   */
  validate(file: File): boolean {
    if (this.options.accept && !this.isFileTypeValid(file)) {
      this.messages.push({
        type: 'genre',
        summary: file.name,
        detail: this.options.accept,
        name: file.name
      });
      return true;
    }
    if (file.size > this.maxFileSize) {
      this.messages.push({
        type: 'size',
        summary: this.formatSize(file.size),
        detail: this.formatSize(this.maxFileSize),
        name: file.name
      });
      return true;
    }
    return false;
  }
  /**
   * 文件类型的验证
   */
  private isFileTypeValid(file: File): boolean {
    let acceptableTypes = this.options.accept.split(',');
    for (let type of acceptableTypes) {
      let acceptable = this.isWildcard(type) ? this.getTypeClass(file.type) === this.getTypeClass(type)
        : this.getFileExtension(file) === type || file.type === type;
      if (acceptable) {
        return true;
      }
    }
    return false;
  }
  /**
   * 删除文件
   */
  remove(i: number, file: any) {
    this.removeFile.emit({ file });
    let unsubscibe = this._us.subject$.subscribe(data => {
      if (data) {
        this.fileList.splice(i, 1);
        unsubscibe.unsubscribe();
      }else {
        this._message.error('删除失败,请重试');
      }
    })
  }
  getTypeClass(fileType: string): string {
    return fileType.substring(0, fileType.indexOf('/'));
  }

  isWildcard(fileType: string): boolean {
    return fileType.indexOf('*') !== -1;
  }

  getFileExtension(file: File): string {
    return file.name.split('.').pop();
  }

  isImage(file: File): boolean {
    return /^image\//.test(file.type);
  }
  onImageLoad(img: any) {
    window.URL.revokeObjectURL(img.src);
  }
  formatSize(bytes) {
    if (bytes === 0) {
      return '0 B';
    }
    let k = 1000,
      dm = 3,
      sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
      i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }
  hasFiles(): boolean {
    return this.files && this.files.length > 0;
  }
  // 预览
  previewPicture(file: File) {
    this.onPreviewPicture.emit({file})
  }
  imageError(e, url) {
    let fileExt = url.substring(url.lastIndexOf('.') + 1);
    e.srcElement.src = this.matchPicture(fileExt);
  }
  matchPicture(fileExt) {
    const fileImgSrc = './../../assets/images/';
    if (fileExt === 'doc' || fileExt === 'docx' || fileExt === 'rtf') {
      return `${fileImgSrc}word.png`
    }else
    if (fileExt === 'ppt' || fileExt === 'pptx' ) {
      return `${fileImgSrc}ppt.png`
    }else
    if (fileExt === 'txt' ) {
      return `${fileImgSrc}txt.png`
    }else
    if (fileExt === 'xls' || fileExt === 'xlsx' ) {
      return `${fileImgSrc}xls.png`
    }else
    if (fileExt === 'ttf'  ) {
      return `${fileImgSrc}ttf.png`
    }else
    if (fileExt === 'zip'  ) {
      return `${fileImgSrc}zip.png`
    }else
    if (fileExt === 'rar'  ) {
      return `${fileImgSrc}rar.png`
    }else
    if (fileExt === 'psd'  ) {
      return `${fileImgSrc}psd.png`
    }else
    if (fileExt === 'swf'  ) {
      return `${fileImgSrc}swf.png`
    }else
    if (fileExt === 'txt'  ) {
      return `${fileImgSrc}txt.png`
    }else {
      return `${fileImgSrc}other.png`
    }
  }
}
